import React from 'react';
import { PlusIcon } from '@beef/ui-kit';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { Accumulate } from "../Accumulate";
import { composeUnit, replaceDotWithComma } from "./utils";
import { pushFubAnalytics } from "../../../utils/analytics";
import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE } from "../../../constants/analytics";
import { getAccumulatorFill, getReplenishLink } from "../../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Accumulator = function Accumulator(_ref) {
  var isLow = _ref.isLow,
    rest = _ref.rest,
    size = _ref.size,
    unit = _ref.unit,
    isUnlimited = _ref.isUnlimited,
    _ref$isLast = _ref.isLast,
    isLast = _ref$isLast === void 0 ? false : _ref$isLast,
    isSvyazZ = _ref.isSvyazZ,
    tariffUrl = _ref.tariffUrl,
    replenishButtonType = _ref.replenishButtonType,
    target = _ref.target,
    userType = _ref.userType;
  var fillPortion = getAccumulatorFill({
    size: size,
    rest: rest,
    isUnlimited: isUnlimited
  });
  var handleAddClick = function handleAddClick(e) {
    e.preventDefault();
    if (replenishButtonType) {
      pushFubAnalytics(target, {
        account_type: userType,
        action: ANALYTICS_ACTION.CLICK,
        item_type: ANALYTICS_ITEM_TYPE.ICON,
        icon_type: 'plus',
        icon_name: 'internet'
      });
      window.location.href = getReplenishLink(replenishButtonType, tariffUrl, isSvyazZ);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container'),
    "data-t-id": "MobileTariff-Accumulator"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('filled', {
      low: isLow
    }),
    style: {
      width: "".concat(fillPortion * 100, "%")
    }
  }), !!replenishButtonType && /*#__PURE__*/React.createElement(Button, {
    className: cn('buy'),
    onClick: handleAddClick,
    size: "l",
    type: "button",
    view: "primary"
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    size: 20,
    "data-t-id": "MobileTariff-Accumulator"
  })), /*#__PURE__*/React.createElement(Accumulate, {
    isLast: isLast
  }, /*#__PURE__*/React.createElement(Text, {
    color: isLow ? 'error' : 'primary',
    variant: isLast ? 'caption-medium' : 'body-small',
    "data-t-id": "MobileTariff-Accumulator"
  }, composeUnit(rest, unit, isUnlimited)), size && /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    variant: "caption-medium"
  }, "\u0438\u0437 ", replaceDotWithComma(size))));
};